export const Messages = {
  defaultErrorMessage:
    'Something went wrong, please refresh the page and try again',
}
